import { render, staticRenderFns } from "./CategoryAttr.vue?vue&type=template&id=36e6deac&scoped=true"
import script from "./CategoryAttr.vue?vue&type=script&lang=js"
export * from "./CategoryAttr.vue?vue&type=script&lang=js"
import style0 from "./CategoryAttr.vue?vue&type=style&index=0&id=36e6deac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e6deac",
  null
  
)

export default component.exports